import { fromApiChannelQuota, toApiChannelQuota } from '../web-widgets/web-widgets.mapper';
import type { MobileSdkBehaviorRequestDto, MobileSdkBehaviorResponseDto } from './mobile-sdks.api.types';
import type { MobileSdkBehavior } from './types';

export function fromApiMobileSdkBehavior(response: MobileSdkBehaviorResponseDto): MobileSdkBehavior {
  return {
    closeOnOutsideClick: response.close_on_outside_click,
    disableZoom: response.disable_zoom,
    displayOnce: response.display_once,
    displayOnceDelayPeriod: response.display_once_delay_period,
    displayRate: response.display_rate,
    feedbackLimit: fromApiChannelQuota(response.channel_quota),
    multipleFeedbackDelayPeriod: response.multiple_feedback_delay_period,
    preventMultipleFeedback: response.prevent_multiple_feedback,
  };
}

export function toApiMobileSdkBehavior(behavior: MobileSdkBehavior): MobileSdkBehaviorRequestDto {
  return {
    channel_quota: toApiChannelQuota(behavior.feedbackLimit),
    close_on_outside_click: behavior.closeOnOutsideClick,
    disable_zoom: behavior.disableZoom,
    display_once: behavior.displayOnce,
    display_once_delay_period: behavior.displayOnceDelayPeriod,
    display_rate: behavior.displayRate,
    multiple_feedback_delay_period: behavior.multipleFeedbackDelayPeriod,
    prevent_multiple_feedback: behavior.preventMultipleFeedback,
  };
}
